export default __webpack_public_path__ + "static/media/Yeezy-Boost-350-V2-Triple-Black.d364ce37.png";